import FingerprintJS from '@fingerprintjs/fingerprintjs';

let fpPromise = null;
let cachedVisitorId = null;

/**
 * 初始化 FingerprintJS 并获取 visitorId
 * 使用缓存避免重复计算
 */
export async function getVisitorId() {
  // 如果已经有缓存的 visitorId，直接返回
  if (cachedVisitorId) {
    return cachedVisitorId;
  }

  // 如果正在初始化，等待初始化完成
  if (!fpPromise) {
    fpPromise = FingerprintJS.load();
  }

  try {
    const fp = await fpPromise;
    const result = await fp.get();
    cachedVisitorId = result.visitorId;
    return cachedVisitorId;
  } catch (error) {
    console.error('Failed to get fingerprint:', error);
    // 如果获取失败，返回一个fallback值
    return 'unknown';
  }
}

/**
 * 清除缓存的 visitorId（用于测试或特殊场景）
 */
export function clearVisitorId() {
  cachedVisitorId = null;
  fpPromise = null;
}
